__turbopack_context__.v({
  "className": "caveat_2f38d7af-module__x0L4yG__className",
});
